import { useQuery, useMutation, useQueryClient } from 'react-query';
import { getCategories,getCategoryById, addCategory, updateCategory, deleteCategory } from '../services/categoryApi';

export const useCategories = (params) => {
  console.log(params)
  return useQuery(['categories', params], () => getCategories(params), {
    keepPreviousData: true,
  });
};

export const useCategory = (id) => {
  return useQuery(['category', id], () => getCategoryById(id), {
    keepPreviousData: true,
  });
}
export const useAddCategory = () => {
  const queryClient = useQueryClient();
  return useMutation(addCategory, {
    onSuccess: () => {
      queryClient.invalidateQueries('categories');
    },
  });
};

export const useUpdateCategory = () => {
  const queryClient = useQueryClient();
  return useMutation(({ id, category }) => updateCategory(id, category), {
    onSuccess: () => {
      queryClient.invalidateQueries('categories');
    },
  });
};

export const useDeleteCategory = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteCategory, {
    onSuccess: () => {
      queryClient.invalidateQueries('categories');
    },
  });
};
